
angular
.module('index')

	// Map view controller
	.controller('EventController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, EventService, $q) {

		var self = this;
		self.eventLoading = true;
		self.event = null;
		self.eventLink = $stateParams.name;
		self.eventID = $stateParams.eventID;
		self.eventToken = $stateParams.eventToken;
		self.eventIsActive = false;
		self.eventTokenObj = null;
		self.errorMessage = null;
		self.eventMessage = null;
		self.pageMessage = null;
		$scope.title = 'test';
		self.registerMultiple = false;
		self.registerMultipleAutoRegister = false;
		
        this.ApiRootUrl = ApiRootUrl;
		
		this.getEvent = function(){
			
			self.pageMessage = null;
			self.event = null;
			
			Classes.Event.get_single({
				link: self.eventLink,
				id: self.eventID,
				token: self.eventToken
			})
			.then(function(event){
				self.eventLoading = false;
				self.event = event;
				if(event){
					//self.formValues['form_data'] = event.event_form.form;
					self.formValues['form_data'] = [];
					MetaService.setMetaKeywords(event.meta_keywords)
					MetaService.setMetaDescription(event.meta_description)
					MetaService.setTitle(event.title)
					MetaService.setContact(event.contact_info)
					MetaService.setVenues(_.uniq(_.map(_.filter(event.event_groups, group => self.isEventGroupAvaliable(group)), function(group){
						return group.venue
					}), '__id'));
					self.formSettingsData = event.event_form.form;
					self.addSurveyFields();
					self.addSurveyPersonFields();   // 1x
					self.addConsentFields();
					self.addGroupSelectionFields();
					self.assignEventToken();
					self.isEventActive();
					self.getEventOtherList(event.__id);

					self.turnOffRegistrationMultiple();
				}

				var eventDefaultGroup = EventService.get('event_default_group');
				if(eventDefaultGroup && eventDefaultGroup[event.__id] && eventDefaultGroup[event.__id].group_id){
					self.formValues['event_group'] = eventDefaultGroup[event.__id].group_id;
				}

				return event;
			}).catch(function(e){
				self.eventLoading = false;
				self.pageMessage = {type:'danger', body: e.data.message};
			});
		}
		self.getEvent();
		
		// get meta service values
		this.getContact = function() {
			return MetaService.get('contact');
		}
		this.getVenues = function() {
			return MetaService.get('venues') ? MetaService.get('venues').filter(item => item != null) : [];
		}
		this.getEventPreviousList = function() {
			return MetaService.get('eventPreviousList');
		}
		this.getEventCurrent = function() {
			return MetaService.get('eventCurrent');
		}
		
		this.getEventOtherList = function(current_id) {
			Classes.Event.get_event_other_list({
				link: $stateParams.name,
				current_id: current_id
			})
			.then(function(list){
				MetaService.setEventPreviousList(list.previous);
				MetaService.setEventCurrent(list.current);
				return list;
			}).catch(function(e){
				
			});
		}
		
		
		this.isEventActive = function(){
			
			if(!self.event)
				return false;
			
			var now = new Date();
			var start = new Date(self.event.visible_start);
			var end = new Date(self.event.visible_end);
			
			now = now.setHours(0,0,0,0);
			start = start.setHours(0,0,0,0);
			end = end.setHours(0,0,0,0);
			
			if(now >= start && now <= end ){
				self.eventIsActive = true;
			}else{
				self.eventMessage = {type:'danger', body: $translate.instant('Form is inactive')};
				self.eventIsActive = false;
			}

			if (!self.formFields[0].length && !self.event.display_alt_location_form && !self.event.hide_group_selection) {
				self.eventMessage = {type:'danger', body: $translate.instant('No event group available')};
				self.eventIsActive = false;
			}
			
			if(self.event.hide_event_form){
				self.eventIsActive = false;
				self.eventMessage = null;
			}
			
		}
		
		this.assignEventToken = function(){
			angular.forEach(self.event.event_tokens, function(tokenItem, key) {
				if(tokenItem.title == self.eventToken)
					self.eventTokenObj = tokenItem;
			});
		}
		
		// Build survey form
		self.formSettingsData = [] //JSON.parse(self.event.event_form.form);
		self.formRegisterData = [];	// form values injected into form schema
		self.formSinglePersonData = {}; // Object of persons data
		self.formRegisterConsents = [];
		self.formRegisterGroup = null;
		self.formRegisterGroupCustom = null;
		self.formFields = [
			[],	// Group Fields
			[],	// Survey Fields
			[],	// Consent Fields
			{}	// Persons Fields
		];
		self.formSurveyFields = [];
		self.formConsentFields = [];
		self.formMessage = null;
		self.formValues = {};	// From values
		self.formLayout = ['survey-form'];
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Participation event_group
				if(!self.event.multi_group_registration){
					self.formRegisterGroups = {};
					if(data.event_group)
						self.formRegisterGroups[data.event_group] = true;
				}else{
					self.formRegisterGroups = data.event_groups;
				}
				self.formRegisterGroupCustom = data.event_group_custom;
				
				// Participation consents
				self.formRegisterConsents.length = 0;
				angular.forEach(self.event.event_consents, function(consent, key) {
					if(data['consent_'+consent.person_consent_option.id])
						self.formRegisterConsents.push(consent.person_consent_option.id);
				});
				
				// Single perons data
				self.formSinglePersonData= {};
				angular.forEach(self.formFields[3], function(personData, key) {
					self.formSinglePersonData[key] = data[key];
				});
				
				// Save survey
				if(self.event.event_form.is_multiple_allowed && self.registerMultiple){
					return Classes.EventParticipationProxy.registration({
						form_data: data.form_data,
						form_single_person_data: self.formSinglePersonData,
						event_id: self.event.__id,
						event_group: self.formRegisterGroup,
						event_groups: self.formRegisterGroups,
						event_group_custom: self.formRegisterGroupCustom,
						event_consents: self.formRegisterConsents,
						token: self.eventToken,
						registration_multiple: self.registerMultiple,
						registration_multiple_auto_register: self.registerMultipleAutoRegister
					}).then(function(resp){
						$state.go('.thankyou');
						//self.errorMessage = "Your registration has been saved";
						self.form.values = [];
						self.scrollToRegisterChapter();
					}).catch(function(e){
						self.errorMessage = e.data.message;
						self.scrollToRegisterChapter();
						return $q.reject(e)  // FormService ustawi field_errors itp.
					});					
				}else{
					return Classes.EventParticipation.registration({
						form_data: data.form_data,
						//form_data: self.formRegisterData, 
						event_id: self.event.__id,
						event_group: self.formRegisterGroup,
						event_groups: self.formRegisterGroups,
						event_group_custom: self.formRegisterGroupCustom,
						event_consents: self.formRegisterConsents,
						token: self.eventToken
					}).then(function(resp){
						$state.go('.thankyou');
						//self.errorMessage = "Your registration has been saved";
						self.form.values = [];
						self.scrollToRegisterChapter();
					}).catch(function(e){
						self.errorMessage = e.data.message;
						self.scrollToRegisterChapter();
						return $q.reject(e)  // FormService ustawi field_errors itp.
					});
				}
				
			},
		}, self.formValues);
		
		this.scrollToRegisterChapter = function(){
			angular.element(window).scrollTop($("#register-chapter").offset().top - 80);
		}
		
		this.addGroupSelectionFields = function(){
			
			self.formFields[0].length = 0;
			angular.forEach(self.event.event_groups, function(group, key) {
				
				var field = {
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'event_group',
					required: true,
					title: group.title,
					type: 'EventGroup',
					visible:"true",
					client: {
						'id': group.id,
						box_template_url: 'partials/index/field-box.html',
						group_date: group.event_full_date,
						// group_date: group.event_start_formatted,
						group_name: group.title
					}
				}
				if(self.isEventGroupAvaliable(group))
					self.formFields[0].push(field);
			});
		}
		
		this.addSurveyFields = function(){
			self.formFields[1].length = 0;
			self.formFields[1].push({
				editable:"true",
				groups:['survey-form'],
				name: 'form_data',
				required: false,
				title: '',
				type: 'FormResultsField',
				visible:"true",
				client: {
					formLabelClass: "text-left",
					formEditorClass: "",
					child_box_template_url: 'partials/index/field-box.html',
					box_template_url: 'partials/index/field-box.html',
				}
			});
		}
		
		this.addConsentFields = function(){
			self.formFields[2].length = 0;
			angular.forEach(self.event.event_consents, function(consent, key) {
				var field = {
					//client:undefined,
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'consent_'+consent.person_consent_option.id,
					required: consent.person_consent_option.required || false,
					title: consent.person_consent_option.title,
					type: 'ConsentOption',
					visible:"true",
					client: {
						'wording': consent.person_consent_option.wording,
						'link': consent.person_consent_option.link || false,
						'id': consent.person_consent_option.id,
						'required': consent.person_consent_option.is_required,
						box_template_url: 'partials/index/field-box.html',
					}
				}
				if(consent.person_consent_option.is_active)
					self.formFields[2].push(field);
			});
		}
		
		this.single_persons_keys = [];
		this.addSurveyPersonFields = function(){
			if(self.personsCountUnderLimit){
				var r = Math.random().toString(36).substring(7);
				self.formValues['form_single_person_data_' + r] = angular.copy(self.event.event_form.single_person_form);
				self.formFields[3]['form_single_person_data_' + r] = {
					editable:"true",
					groups:['survey-form'],
					name: 'form_single_person_data_' + r,
					required: false,
					title: '',
					type: 'FormResultsField',
					visible:"true",
					client: {
						formLabelClass: "text-left",
						formEditorClass: "",
						child_box_template_url: 'partials/index/field-box.html',
						box_template_url: 'partials/index/field-box.html',
					}
				};
				self.single_persons_keys.push('form_single_person_data_' + r);
			}
			self.checkGroupParticipantsCount();
		}
		
		this.removeSurveyPersonFields = function(index){
			delete self.formValues[index];
			delete self.formFields[3][index];
			//self.single_persons_keys.splice(index, 1);
			self.single_persons_keys.splice(self.single_persons_keys.indexOf(index), 1);
			self.checkGroupParticipantsCount();
		}
		
		this.personsCountUnderLimit = true;
		this.peronsOverflowMessage = null;
		this.personsGroupLimitCount = 0;
		//this.personsTokenLimitCount = 0;
		//this.personsTotalLimitCount = 0;
		this.checkGroupParticipantsCount = function(){
			self.personsCountUnderLimit = true;

			if(self.selectedGroup && self.selectedGroup.max_participants && self.selectedGroup.max_participants - self.selectedGroup.count_participants <= self.single_persons_keys.length){
				self.personsCountUnderLimit = false;
				self.peronsOverflowMessage = 'Osiągnięto limit wolnych miejsc dla wybranego terminu';
			}

			if(self.eventTokenObj && self.eventTokenObj.max_participants && self.eventTokenObj.max_participants - self.eventTokenObj.count_participants <= self.single_persons_keys.length){
				self.personsCountUnderLimit = false;
				self.peronsOverflowMessage = 'Osiągnięto limit wolnych miejsc dla zaproszenia';
			}
			
			if(self.selectedGroup && self.selectedGroup.max_participants)
				self.personsGroupLimitCount = self.selectedGroup.max_participants - self.selectedGroup.count_participants;
			else
				self.personsGroupLimitCount = 0;
			
			/*
			if(self.eventTokenObj)
				self.personsTokenLimitCount = self.eventTokenObj.max_participants - self.eventTokenObj.count_participants;
			else
				self.personsTokenLimitCount = 0;
			*/
			/*
			if(self.personsTokenLimitCount && self.personsGroupLimitCount)
				self.personsTotalLimitCount = Math.min(self.personsTokenLimitCount, self.personsGroupLimitCount);
			else if(self.personsTokenLimitCount)
				self.personsTotalLimitCount = self.personsTokenLimitCount
			else if(self.personsGroupLimitCount)
				self.personsTotalLimitCount = self.personsGroupLimitCount
			else
				self.personsTotalLimitCount = 0;
			*/
			//console.log(self.personsTokenLimitCount);
		}

		this.selectedGroup = null;		
		$scope.$watch(function(){return self.form.values.event_group;}, function(newValue, oldValue) {
			self.selectedGroup = null;
			if(self.event && self.event.event_groups){
				angular.forEach(self.event.event_groups, function(group, key) {
					if(group.id == newValue){
						self.selectedGroup = group;
					}
				});
			}
			self.checkGroupParticipantsCount();
			/*
			angular.forEach(self.formFields[3], function(personData, key) {				
				self.removeSurveyPersonFields(key);
			});	
			self.addSurveyPersonFields();
			*/
		});

		this.isEventGroupAvaliable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);
			
			now = now.getTime();
			start = start.getTime();
			end = end.getTime();

			if(now < start || now > end )
				return false;
			
			if (group.is_blocked || group.is_hidden)
				return false;
			
			return true;
		}
		
		this.turnOnRegistrationMultiple = function(auto_register){
			auto_register=auto_register||false;
			//self.personsTotalLimitCount = 0;
			self.registerMultiple = true;
			self.registerMultipleAutoRegister = auto_register;
			if(!self.single_persons_keys.length)
				self.addSurveyPersonFields();
			self.formValues['form_data'] = self.event.event_form.form;
		}
		
		this.turnOffRegistrationMultiple = function(){
			self.registerMultiple = false;
			self.registerMultipleAutoRegister = false;
			angular.forEach(self.formFields[3], function(personData, key) {				
				self.removeSurveyPersonFields(key);
			});
			//var form_fields = angular.copy(self.event.event_form.form);
			//self.formValues['form_data'] = form_fields;
			self.formValues['form_data'] = self.event.event_form.form;
		}

		this.goMainPage = function(){
			$state.go('index', {});
		}		
		

		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;
